import { render, staticRenderFns } from "./states.vue?vue&type=template&id=32ff2196&"
import script from "./states.vue?vue&type=script&lang=js&"
export * from "./states.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports